// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import InventoryIcon from '@mui/icons-material/Inventory';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    InventoryIcon,
    MoveUpIcon,
    AddToPhotosIcon,
    ListAltIcon,
    SwipeRightIcon
}

// ==============================|| INVENTARIO MENU ITEMS ||============================== //

const inventario = {
    id: 'inventario',
    title: '',
    type: 'group',
    children: [
        {
            id: 'inventarioMainMenu',
            title: 'Inventario',
            type: 'collapse',
            icon: icoMenu.InventoryIcon,
            children: [
                {
                    id: 'kardex',
                    title: 'Kardex',
                    type: 'collapse',
                    icon: icoMenu.MoveUpIcon,
                    children: [
                        {
                            id: 'nuevo_kardex',
                            title: 'Nuevo Kardex',
                            type: 'item',
                            icon: icoMenu.AddToPhotosIcon,
                            url: '/user/new-kardex-view/0'
                        },
                        {
                            id: 'mover_kardex',
                            title: 'Mover Kardex',
                            type: 'item',
                            icon: icoMenu.MoveUpIcon,
                            url: '/user/move-kardex-view/0'
                        },
                        {
                            id: 'lista_kardex',
                            title: 'Lista Kardex',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-kardex-view'
                        },
                        {
                            id: 'actualizar_lotes',
                            title: 'Actualizar lotes',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-actualizar-lotes-view'
                        },
                        {
                            id: 'cruce_lotes_temporales',
                            title: 'Cruce lotes temporales',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/cruce-lotes-temporales'
                        },
                        {
                            id: 'lista_kardex_cuarentena',
                            title: 'Kardex Cuarentena',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-kardex-cuarentena-view'
                        },
                        {
                            id: 'lista_kardex_rechazado',
                            title: 'Bodega de Rechazados y Proximos a Caducar',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-kardex-rechazado-view'
                        },
                        {
                            id: 'lista_kardex_caducado',
                            title: 'Kardex Caducado',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-kardex-caducado-view'
                        },
                        {
                            id: 'lista_kardex_approve',
                            title: 'Aprobar Productos',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-kardex-approve-view'
                        },                
                    ]
                },
            ]
        }
    ]
};

export default inventario;
